import {AppThunk} from '../../index';
import {stateProgramSlice} from '../../../reducers/socialSupport/statePrograms';
import data from './data';
import {StateProgram} from '../../../../shared/models/socialSupport/stateProgram';
import {sleep} from '../../../../shared/pipes/sleep';

export const setStatePrograms = stateProgramSlice.actions.setStatePrograms;

export const getStatePrograms = (): AppThunk => {
  return async (dispatch) => {
    // const response = await httpService.get<StateProgram[]>(getApiRoute(urls.getStatePrograms));
    await sleep(10);
    const response = data as StateProgram[]; // ToDo: заменить на вызов api когда будет доступен
    dispatch(setStatePrograms(response));
  };
};
